// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"h2-z"};